import { Injectable, OpaqueToken } from "@angular/core";
/**
 * Base class for the the two configuration services.
 */
export class ConfigurationServiceConstants {
    /**
     * Add the specified configuration to the given configurations map.
     * @param configurations
     * @param category
     * @param configName
     * @param contextSpecKey
     * @param contextSpec
     * @param value
     */
    static setConfiguration(configurations, category, configName, contextSpecKey, contextSpec, value) {
        if (!configurations.hasOwnProperty(category)) {
            configurations[category] = {};
        }
        let configurationMap = configurations[category];
        if (!configurationMap.hasOwnProperty(configName)) {
            configurationMap[configName] = {};
        }
        let contextSpecMap = configurationMap[configName];
        contextSpecMap[contextSpecKey] = value;
        if (!configurations.hasOwnProperty("contextSpecs")) {
            configurations["contextSpecs"] = {};
        }
        let contextSpecs = configurations['contextSpecs'];
        contextSpecs[contextSpecKey] = contextSpec;
    }
}
ConfigurationServiceConstants.configSpecPattern = /(.*?)\/(.*)/;
/**
 * Provider application key - identifies the application in the configuration context.
 * @type {OpaqueToken}
 */
ConfigurationServiceConstants.APPLICATION_KEY = new OpaqueToken('applicationKey');
/**
 * Provider context names key - specifies the order of context names in the configuration context.
 * @type {OpaqueToken}
 */
ConfigurationServiceConstants.CONTEXT_NAMES_KEY = new OpaqueToken('contextNames');
/**
 * Provider local config file key - specifies the location of the local config file.
 * @type {OpaqueToken}
 */
ConfigurationServiceConstants.LOCAL_CONFIG_FILE_KEY = new OpaqueToken('localConfigFile');
/**
 * Key for locally stored configuraions
 * @type {string}
 */
ConfigurationServiceConstants.LOCAL_STORAGE_KEY = "localConfigurations";
ConfigurationServiceConstants.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ConfigurationServiceConstants.ctorParameters = () => [];
//# sourceMappingURL=configuration-service-constants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/configuration/configuration-service-constants.js
// module id = 101
// module chunks = 1